import { StrictMode, startTransition } from "react";

import * as Sentry from "@sentry/react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

import { getAppConfig } from "@/config";

import { initI18n } from "./lib/i18n.client";

Sentry.init({
    dsn: import.meta.env.NEXT_PUBLIC_SENTRY_DSN,
    enabled: Boolean(import.meta.env.NEXT_PUBLIC_SENTRY_DSN),
    environment: getAppConfig("appEnv"),
    integrations: [Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

async function main() {
    await initI18n();

    startTransition(() => {
        hydrateRoot(
            document,
            <StrictMode>
                <HydratedRouter />
            </StrictMode>
        );
    });
}

main();
